import Vue from 'vue'

import 'bootstrap'
import jQuery from 'jquery'
import toastr from 'toastr'
import popper from 'popper.js'
import 'datatables.net-bs4'
import 'datatables.net-responsive-bs4'

import 'bootstrap/dist/js/bootstrap.bundle';
import languageDatatable from './vendor/datatables/lang/fr'
import 'select2'
import languageSelect2 from './vendor/select2/lang/fr'
import {
    startOfYear,
    startOfMonth,
    endOfMonth,
    startOfDay,
    subMonths,
    subDays
} from 'date-fns/esm'
import 'daterangepicker'
import { Chart, Tooltip, Legend } from "chart.js";
import Dropzone from 'dropzone/dist/dropzone'
import Swal from 'sweetalert2'

// IMPORT LOCALS
import './defaults'

//Gilde
import Glide from "@glidejs/glide";

//variables
window.jQuery = jQuery
window.$ = jQuery

// TOOLTIP TIPPY
window.Popper = popper

window.startOfYear = startOfYear
window.startOfMonth = startOfMonth
window.endOfMonth = endOfMonth
window.startOfDay = startOfDay
window.subMonths = subMonths
window.subDays = subDays

window.Vue = Vue
window.Toastr = toastr;
Toastr.options = {
    "showDuration": "5000",
    "hideDuration": "5000",
    "timeOut": "5000",
    "extendedTimeOut": "5000",
}
window.Chart = Chart;
Chart.register(Legend);
Chart.register(Tooltip);
window.Dropzone = Dropzone
window.Swal = Swal
window.languageDatatable = languageDatatable
window.languageSelect2 = languageSelect2
window.axios = require('axios')
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
window.BASE_URL = window.location.protocol + "//" + document.domain + "/";
window.Glide = Glide;

/**
 * Register CSRF Token
 */
let token = document.head.querySelector('meta[name="csrf-token"]')
// let token = document.getElementsByName('csrf-token')[0].getAttribute('content')

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content
} else {
    throw ('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token')
}

window.swalConfirm = Swal.mixin({
    customClass: {
        confirmButton: 'btn btn-primary mx-4',
        cancelButton: 'btn btn-dark mx-4'
    },
    confirmButtonText: 'Valider',
    cancelButtonText: 'Annuler',
    showCancelButton: true,
})

window.Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})

import {
    ValidationProvider,
    ValidationObserver,
    extend,
    configure,
    setInteractionMode,
} from "vee-validate";

setInteractionMode("dirtyValidate", ({ errors }) => {
    if (errors.length) {
        return {
            on: ["change"],
        };
    }

    return {
        on: ["dirty", "change"],
    };
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.filter('pluralize', (amount, singular, plural) => (amount > 1) ? plural : singular);
Vue.filter('splitPhoneNumber', function (value) {
    if (value != undefined || value != null) {
        return value.toString().replace(/\B(?=(\d{2})+(?!\d))/g, " ");
    }
    return null;
})
Vue.filter('thousandSeparator', function (value) {
    return value ? value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") : 0;
})

import { dict } from "./vuejs/validation/dictionary";
import { required, size, email, ext, min, max, numeric, is_not } from "vee-validate/dist/rules";
extend("required", required);
extend('email', email);
extend('numeric', numeric);
extend("size", size);
extend("min", min);
extend("max", max);
extend("ext", ext);
extend("is_not", is_not);

const mobileRegex = /^(\+33|0)\s*[6-7]([\s./-]*\d{2}){4}$/;
const fixRegex = /^(\+33|0)\s*[1-5|8-9]([\s./-]*\d{2}){4}$/;
const phoneRegex = /^(\+33|0)\s*[1-9]([\s./-]*\d{2}){4}$/;
const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

configure({
    defaultMessage: (field, values) => {
        return dict[field] !== undefined ? dict[field][values._rule_] : false
    },
    classes: {
        valid: 'is-valid',
        invalid: 'is-invalid'
    }
});

extend("mobileNumber", {
    validate: value => mobileRegex.test(value),
    message: () => `Veuillez entrer un numéro de mobile valide.`
});

extend("fixNumber", {
    validate: value => fixRegex.test(value),
    message: () => `Veuillez entrer un numéro de téléphone fixe valide.`
});

extend("phoneRegex", {
    validate: value => phoneRegex.test(value),
    message: () => `Veuillez entrer un numéro de téléphone valide.`
});

extend('password', {
    params: ['target'],
    validate(value, { target }) {
        return value === target;
    },
    message: 'Le mot de passe et sa confirmation ne correspondent pas.'
});

extend('passwordSecurity', {
    validate: value => passwordRegex.test(value),
    message: 'Le mot de passe doit contenir au moins: 8 caractères, une lettre minuscule, une lettre majuscule, un chiffre et un caractère spécial (@$!%*#?&-_.)'
});

extend('min', {
    params: ['target'],
    validate(value, { target }) {
        //Do not edit this condition
        if (target === undefined && value >= 0) {
            return true
        }
        else if (parseInt(value) >= parseInt(target)) {
            return true
        }
        return false
    },
    message: (fieldName, placeholders) => {
        if (!placeholders._target_ && placeholders.target !== null) {
            return `La valeur saisie doit être supérieure ou égale à ${placeholders.target}`
        }
        return `La valeur saisie doit être supérieure ou égale à ${placeholders._target_}`
    }
});

extend('max', {
    params: ['target'],
    validate(value, { target }) {
        //Do not edit this condition
        if (target === undefined) {
            return true
        }
        else if (parseInt(value) <= parseInt(target)) {
            return true
        }
        return false
    },
    message: (fieldName, placeholders) => {
        if (!placeholders._target_ && placeholders.target !== null) {
            return `La valeur saisie doit être inférieure ou égale à ${placeholders.target}`
        }
        return `La valeur saisie doit être inférieure ou égale à ${placeholders._target_}`
    }
});

extend('minPalier', {
    params: ['target', 'minPalier'],
    validate(value, { target }) {
        //Do not edit this condition
        if (target === undefined && value >= 0) {
            return true
        }
        else if (parseInt(value) > parseInt(target)) {
            return true
        }
        return false
    },
    message: (fieldName, placeholders) => {
        if (placeholders._target_ === null) {
            return `La valeur du bien précédent doit avoir une valeur supérieure ou égale à 0`
        }
        return `La valeur saisie doit être supérieure à ${placeholders._target_}`
    }
});

extend('minRecompense', {
    params: ['target', 'minRecompense'],
    validate(value, { target }) {
        //Do not edit this condition
        if (target === undefined && value >= 0) {
            return true
        }
        else if (parseInt(value) > parseInt(target)) {
            return true
        }
        return false
    },
    message: (fieldName, placeholders) => {
        if (placeholders._target_ === null) {
            return `La récompense du palier précédent doit avoir une valeur supérieure ou égale à 0`
        }
        return `La récompense saisie doit être supérieure à ${placeholders._target_}`
    }
});

extend('minLength', {
    params: ['target'],
    validate(value, { target }) {
        //Do not edit this condition
        if (target === undefined && value >= 0) {
            return true
        }
        else if (parseInt(value.length) >= parseInt(target)) {
            return true
        }
        return false
    },
    message: (fieldName, placeholders) => {
        return `La valeur saisie doit être supérieure à ${placeholders._target_}`
    }
});

extend('maxLength', {
    params: ['target'],
    validate(value, { target }) {
        //Do not edit this condition
        if (target === undefined) {
            return true
        }
        else if (parseInt(value.length) <= parseInt(target)) {
            return true
        }
        return false
    },
    message: (fieldName, placeholders) => {
        return `La valeur saisie doit être inférieure à ${placeholders._target_}`
    }
});

// INIT
document.addEventListener("DOMContentLoaded", function () {
    if (document.getElementById("nav-profile")) {
        new Vue({
            el: "#nav-profile",
            components: {
                "user-account": () => import("./vuejs/components/Forms/UserAccount.vue"),
            },
        });
    }

    if (document.getElementById("nav-password")) {
        new Vue({
            el: "#nav-password",
            components: {
                "user-password": () => import("./vuejs/components/Forms/UserPassword.vue"),
            },
        });
    }

    if (document.getElementById("user-first-time")) {
        new Vue({
            el: "#user-first-time",
            components: {
                "user-first-time": () => import("./vuejs/components/Forms/UserFirstTime.vue"),
            },
        });
    }

    if (document.getElementById("accept-sponsorship")) {
        new Vue({
            el: "#accept-sponsorship",
            components: {
                "accept-sponsorship": () => import("./vuejs/components/Forms/AcceptSponsorship.vue"),
            },
        });
    }

    if (document.getElementById("accept-sponsor")) {
        new Vue({
            el: "#accept-sponsor",
            components: {
                "accept-sponsor": () => import("./vuejs/components/Forms/AcceptSponsor.vue"),
            },
        });
    }

    if (document.getElementById("agency-informations")) {
        new Vue({
            el: "#agency-informations",
            components: {
                "agency-informations": () => import("./vuejs/components/Agency/Informations.vue"),
                "agency-program": () => import("./vuejs/components/Agency/Program.vue"),
            },
        });
    }

    $(document).ready(function () {
        $("body").tooltip({
            selector: '[data-toggle=tooltip]'
        });
    });
});
